import HttpClientSAIP from '@/common/boot/HttpClientSAIP'
import HttpClientModos from '@/common/boot/HttpClientModos'
import HttpClient from "@/common/boot/HttpClient"

const consultaSEV = async({ commit }, payload) => {
  let params = {
    'sev': payload,
    'pco_circuito_id': 0
  };

  const response =  await HttpClient.get('/integracao/ssa',  { params });

  commit('LISTAR_DADOS', response.data.message.success);
  return response;
}

const consultaCLA = async({ commit }, payload) => {
  commit('BUSCANDO', true);

  let params = {
    'hdnSolId': payload
  };

  try {
    const response = await HttpClient.get('/integracao/cla', { params });
    commit('LISTAR_DADOS', response.data);
    return response;
  } catch (error) {
    console.error('Erro na requisição:', error);
    throw error;
  } finally {
    commit('BUSCANDO', false);
  }
}

const listarSAIP = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  try {
    if (!Array.isArray(payload)) {
      throw new Error('Payload deve ser uma lista de objetos');
    }

    const response = await HttpClientSAIP.post('/saip/buscarDadosSaip', payload); 

    commit('LISTAR_DADOS', response.data);

    return response;
  } catch (error) {
    console.error('Erro na requisição:', error);
    throw error;
  } finally {
    commit('BUSCANDO', false);
  }
};

const listarSAPWEB = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  try {
    if (!Array.isArray(payload)) {
      throw new Error('Payload deve ser uma lista de objetos');
    }

    const response = await HttpClientSAIP.post('/sapWeb/buscarDadosSapWeb', payload);

    commit('LISTAR_DADOS', response.data.data);



    return response; // Assuming you might want to return the response for further handling in components
  } catch (error) {
    // Handle error appropriately
    console.error('Error fetching SAPWEB data:', error);
    throw error; // Propagate the error to be handled in components or elsewhere
  } finally {
    commit('BUSCANDO', false);
  }
};

const listarWF1 = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  try {
    if (isNaN(payload.numeroOs)) {
      commit('BUSCANDO', false);
      throw new Error('Número da OS é obrigatório');
    }
    const response = await HttpClient.post('/integracao/wf1', payload);

    commit('LISTAR_DADOS', response.data);

    return response; // Assuming you might want to return the response for further handling in components
  } catch (error) {
    // Handle error appropriately
    console.error('Error fetching WF1 data:', error);
    throw error; // Propagate the error to be handled in components or elsewhere
  } finally {
    commit('BUSCANDO', false);
  }
};



const filtrarCpes = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  try {

    const response = await HttpClientModos.post('/gestao-equipamento/pco-cpes/filtrar-cpes', payload);

    commit('LISTAR_DADOS', response.data.data);

    return response; // Assuming you might want to return the response for further handling in components
  } catch (error) {
    // Handle error appropriately
    console.error('Error fetching MODOS data:', error);
    throw error; // Propagate the error to be handled in components or elsewhere
  } finally {
    commit('BUSCANDO', false);
  }
}


// http://10.88.136.66:8082/api/gestao-equipamento/pco-cpes/249294
// apos conseguir o cpeid necessario fazer nova consulta
// http://10.88.136.66:8082/api/gestao-equipamento/pco-cpes/filtrar-cpes
const listarCpe = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  HttpClientModos.post('/gestao-equipamento/pco-cpes/filtrar-cpes', payload).then(response => {
    commit('LISTAR_DADOS', response.data.data)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })

  return true
}

const listarUmCpe = async ({ commit }, payload) => {
  commit('BUSCANDO', true);
  const URL = `/gestao-equipamento/pco-cpes/${payload.pco_cpe_id}`; // Use template literals here

  const responses = HttpClientModos.get(URL).then(response => {
    commit('LISTAR_CPE', response.data.data)
    return response.data.data;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })

  return responses
}

export {
  listarSAIP,
  listarSAPWEB,
  listarWF1,
  filtrarCpes,
  listarCpe,
  listarUmCpe,
  consultaCLA,
  consultaSEV
  }